(function () {
  function initArrows() {
    document.querySelectorAll('[data-lookbook-arrow]').forEach(function (arrow) {
      if (arrow.dataset.bound) return;
      arrow.dataset.bound = 'true';
      var gallery = arrow.closest('.lookbook__gallery-wrap').querySelector('[data-lookbook-gallery]');
      var direction = arrow.dataset.lookbookArrow === 'prev' ? -1 : 1;
      arrow.addEventListener('click', function () {
        gallery.scrollBy({ left: gallery.clientWidth * direction, behavior: 'smooth' });
      });
    });
  }

  function initLightbox() {
    var lightbox = document.querySelector('[data-lookbook-lightbox]');
    if (!lightbox) return;
    var image = lightbox.querySelector('[data-lookbook-lightbox-image]');
    var closeButton = lightbox.querySelector('[data-lookbook-lightbox-close]');

    function open(src, alt) {
      image.src = src;
      image.alt = alt || '';
      lightbox.hidden = false;
      document.body.style.overflow = 'hidden';
    }

    function close() {
      lightbox.hidden = true;
      image.src = '';
      document.body.style.overflow = '';
    }

    document.querySelectorAll('[data-lookbook-photo]').forEach(function (photo) {
      if (photo.dataset.bound) return;
      photo.dataset.bound = 'true';
      photo.addEventListener('click', function () {
        open(photo.dataset.fullSrc, photo.dataset.fullAlt);
      });
    });

    closeButton.addEventListener('click', close);
    lightbox.addEventListener('click', function (event) {
      if (event.target === lightbox) close();
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !lightbox.hidden) close();
    });
  }

  function init() {
    initArrows();
    initLightbox();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
